export const ALPHA_PAGE_INIT = 'ALPHA_PAGE_INIT';
export const ALPHA_PING_TRIGGER = 'ALPHA_PING_TRIGGER';
export const ALPHA_PING_API_REQUEST = 'ALPHA_PING_API_REQUEST';
export const ALPHA_PING_API_SUCCESS = 'ALPHA_PING_API_SUCCESS';
export const ALPHA_PING_API_FAILURE = 'ALPHA_PING_API_FAILURE';
